import axios from 'axios';
import { toast } from 'react-toastify';
import NProgress from 'nprogress';
 /* --------------------------------------------------
  * 로그인 상태 플래그 (AuthProvider가 갱신)
  * ------------------------------------------------- */
export let isLoggedIn = false;
export const setIsLoggedIn = (v) => { isLoggedIn = v };

// 로그아웃 콜백 함수를 저장할 변수
let logoutCallback = () => {};
export const setLogoutCallback = (callback) => {
    logoutCallback = callback;
};

NProgress.configure({ showSpinner: false, trickleSpeed: 180 });

//const BASE_URL = process.env.REACT_APP_BOOT_URL;
const axios_api = axios.create({
  //baseURL: `${BASE_URL}/api`,
  baseURL: '/api',
  withCredentials: true,
  timeout: 10000,
});


axios_api.interceptors.request.use((cfg) => {
  NProgress.start();
  return cfg;
});



// ---------------------------------------------------------------------
// 에러 알림 캐시 설정 (예: 15초 창, 최대 1회)
// ---------------------------------------------------------------------
const ERR_CACHE  = {};
const WINDOW  = 15000;
const MAX_COUNT  = 1;

const shouldShow = (msg) => {
  const now = Date.now();
  const c = ERR_CACHE[msg];
  if (!c || now - c.last > WINDOW) {
    ERR_CACHE[msg] = { count: 1, last: now };
    return true;
  }
  if (c.count < MAX_COUNT) {
    c.count += 1; c.last = now; return true;
  }
  return false;
};


function getHttpErrorMessage(status) {
    switch (status) {
      case 400:
        return '잘못된 요청입니다.';
      case 403:
        return '접근 권한이 거부되었습니다.';
      case 404:
        return '요청한 페이지를 찾을 수 없습니다.';
      case 500:
        return '서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.';
      case 423:
        return '로그인 시도가 너무 많습니다. 잠시후 다시 시도해 주세요';
      case 410:
        return '삭제된 계정입니다.';  
      default:
        return '알 수 없는 오류가 발생했습니다.';
    }
}

axios_api.interceptors.response.use(
  (res) => {
    NProgress.done();

    const body = res.data;
    if (body && typeof body === 'object' && body.status === false) {
      const bizMsg = body.message || '알 수 없는 오류가 발생했습니다.';
      if (body.silent !== true && shouldShow(bizMsg)) {
          toast.error(bizMsg);
        }

        const bizErr = new Error(bizMsg);
        bizErr.isBizError = true;
        bizErr.data = body;
        return Promise.reject(bizErr);
    }

    return res;
  },
  (err) => {
    NProgress.done();

    const status = err.response?.status;
    const path   = err.config?.url || '';
    const msg =
      err.response?.data?.errorMessage ||
      err.response?.data?.message ||
      getHttpErrorMessage(status) ||
      err.message ||
      '알 수 없는 오류가 발생했습니다.';

    /* 401 → 자동 로그아웃 (로그인 시도 자체는 제외) */
    if (status === 401 && !path.endsWith('/login')) {
      if (isLoggedIn) logoutCallback(true);
    } else if (status >= 400 && status < 600) {
      if (shouldShow(msg)) toast.error(msg);
    } else if (err.request) {
      if (shouldShow('서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.')) {
        toast.error('서버와의 연결이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.');
      }
    }

    return Promise.reject(err);
  },
);

export const get = async (url, config = {}) => {
    const response = await axios_api.get(url, config);
    return response.data;
};

export const post = async (url, data, config = {}) => {
    const response = await axios_api.post(url, data, config);

    if (config.responseType === 'blob') {
        return response;
      }

    return response.data;
};

export const put = async (url, data, config = {}) => {
    const response = await axios_api.put(url, data, config);
    return response.data;
};

export const del = async (url, config = {}) => {
    const response = await axios_api.delete(url, config);
    return response.data;
};

export default axios_api;
